module.exports = "https://cdn.zapier.com/blog/9bdf6c1b0e1defd015c6304f538aae479177ea11/_next/static/images/orange-cc7d7511764b8e94e76fbcd163b076ff.png";